<ft-fund-document-card
  *ngFor="let data of rowData"
  edsCol
  [columnNumbers]="{ s: 4, m: 8, l: 10 }"
  edsSpacing="sm"
  [rowData]="data"
  [columnDefs]="columnDefs"
  [gridContext]="gridContext"
  (selectionEmitter)="onSelectionChanged($event)"
>
</ft-fund-document-card>
